import React from 'react'

import {connect} from 'react-redux'
import {Col, Modal, Radio, Row, Tag, Typography} from "antd";
import SubscriptionPlan from "../../component/subscription/SubscriptionPlan"
import {AccountBookOutlined} from "@ant-design/icons";
import withBreakpoint from "../../app/withBreakpoint";
import {URL_BILLING, URL_SUBSCRIPTION_CANCEL, URL_SUBSCRIPTION_FAILED, URL_SUBSCRIPTION_SUCCESS} from "../../const";
import {withRouter} from "react-router";
import {getArtist} from "../../api/artists";
import axios from "axios";

const {Title} = Typography

@connect(
    (state) => ({
        id: state.user.info.id, // real user id, admin_id or artist_id
        userId: state.user.info.userId, // artist user obj id
        artistId: state.user.info.artistId, // artist obj id
        artistName: state.user.info.artistName,
        email: state.user.info.email,
        role: state.user.info.role,
        plan: state.user.plan
    }),
    {}
)
class Subscription extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            paymentPeriod: "yearly",
        }

        this.paymentPeriodOptions = [
            {
                label: 'Yearly',
                value: 'yearly',
            },
            {
                label: 'Monthly',
                value: 'monthly'
            }
        ]

        this.basicPlanBenefits = [
            {
                type: 'Art Inventory & Website',
                text: "Manage Pieces",
                inPlan: true
            },
            {
                text: "Manage Collections",
                inPlan: true
            },
            {
                text: "Personal Website Design",
                inPlan: true
            },
            {
                text: "Personal Domain",
                inPlan: false
            },
            {
                text: "Export Art Label",
                inPlan: false
            },
            {
                text: "Export Catalog",
                inPlan: false
            },
            {
                text: "AI Tools",
                inPlan: true
            },
            {
                type: 'Art Business',
                text: "Integrated CRM",
                inPlan: false
            },
            {
                text: "Agreement Center",
                inPlan: false
            },
            {
                text: "Training Workshops",
                inPlan: true
            },
            {
                text: "Customized E-Commerce Setup",
                inPlan: false
            },
            {
                text: "Giclée Print Business",
                inPlan: false
            },
            {
                text: "Customer Service",
                inPlan: true
            },
            {
                text: "Commission on Art Sales (70%)",
                inPlan: true
            },
            {
                type: 'Opportunities & Marketing',
                text: "Exhibition Opportunities (Limited)",
                inPlan: true
            },
            {
                text: "Public Art Opportunities",
                inPlan: false
            },
            {
                text: 'Social Media Promotion',
                inPlan: false
            },
            {
                text: 'PR Press Service',
                inPlan: false
            },
            {
                text: 'Artist Consultation',
                inPlan: false
            },
        ]

        this.premiumPlanBenefits = [
            {
                type: 'Art Inventory & Website',
                text: "Manage Pieces",
                inPlan: true
            },
            {
                text: "Manage Collections",
                inPlan: true
            },
            {
                text: "Personal Website Design",
                inPlan: true
            },
            {
                text: "Personal Domain",
                inPlan: true
            },
            {
                text: "Export Art Label",
                inPlan: true
            },
            {
                text: "Export Catalog",
                inPlan: true
            },
            {
                text: "AI Tools",
                inPlan: true
            },
            {
                type: 'Art Business',
                text: "Integrated CRM",
                inPlan: true
            },
            {
                text: "Agreement Center",
                inPlan: true
            },
            {
                text: "Training Workshops",
                inPlan: true
            },
            {
                text: "Customized E-Commerce Setup",
                inPlan: false
            },
            {
                text: "Giclée Print Business (Set up)",
                inPlan: true
            },
            {
                text: "Customer Service (Email support)",
                inPlan: true
            },
            {
                text: "Commission on Art Sales (70%)",
                inPlan: true
            },
            {
                type: 'Opportunities & Marketing',
                text: "Exhibition Opportunities (Full access)",
                inPlan: true
            },
            {
                text: "Public Art Opportunities",
                inPlan: true
            },
            {
                text: 'Social Media Promotion (Limited)',
                inPlan: true
            },
            {
                text: 'PR Press Service',
                inPlan: false
            },
            {
                text: 'Artist Consultation',
                inPlan: false
            },
        ]

        this.proPlanBenefits = [
            {
                type: 'Art Inventory & Website',
                text: "Manage Pieces",
                inPlan: true
            },
            {
                text: "Manage Collections",
                inPlan: true
            },
            {
                text: "Personal Website Design",
                inPlan: true
            },
            {
                text: "Personal Domain",
                inPlan: true
            },
            {
                text: "Export Art Label",
                inPlan: true
            },
            {
                text: "Export Catalog",
                inPlan: true
            },
            {
                text: "AI Tools",
                inPlan: true
            },
            {
                type: 'Art Business',
                text: "Integrated CRM",
                inPlan: true
            },
            {
                text: "Agreement Center",
                inPlan: true
            },
            {
                text: "Training Workshops",
                inPlan: true
            },
            {
                text: "Customized E-Commerce Setup",
                inPlan: true
            },
            {
                text: "Giclée Print Business (Full service)",
                inPlan: true
            },
            {
                text: "Customer Service (Concierge service)",
                inPlan: true
            },
            {
                text: "Commission on Art Sales (80%)",
                inPlan: true
            },
            {
                type: 'Opportunities & Marketing',
                text: "Exhibition Opportunities (Priority access)",
                inPlan: true
            },
            {
                text: "Public Art Opportunities",
                inPlan: true
            },
            {
                text: 'Social Media Promotion (Full support)',
                inPlan: true
            },
            {
                text: 'PR Press Service',
                inPlan: true
            },
            {
                text: 'Artist Consultation',
                inPlan: true
            },
        ]

        this.discount_rate = 0

        this.prices = {
            'basic': {
                'price_monthly': 8,
                // 'price_monthly_discount': (8 * (1-this.discount_rate)).toFixed(2),
                'price_yearly': 6,
                // 'price_yearly_discount': (6 * (1-this.discount_rate)).toFixed(2)
            },
            'premium': {
                'price_monthly': 25,
                // 'price_monthly_discount': (25 * (1-this.discount_rate)).toFixed(2),
                'price_yearly': 18,
                // 'price_yearly_discount': (18 * (1-this.discount_rate)).toFixed(2)
            },
            'pro': {
                'price_monthly': 50,
                // 'price_monthly_discount': (50 * (1-this.discount_rate)).toFixed(2),
                'price_yearly': 36,
                // 'price_yearly_discount': (36 * (1-this.discount_rate)).toFixed(2)
            }
        }

        this.checkInterval = null

        this.CancelToken = axios.CancelToken.source()
    }

    paymentPeriodChange = (e) => {
        this.setState({
            paymentPeriod: e.target.value
        })
    }

    checkSubscriptionStatus = () => {
        try {
            function getDays(end) {
                try {
                    let expireDate = new Date(end);
                    const startDate = new Date();

                    // Calculate the difference in milliseconds
                    const timeDifference = expireDate.getTime() - startDate.getTime();

                    // Convert milliseconds to days
                    return Math.floor(timeDifference / (1000 * 60 * 60 * 24))
                } catch (e) {
                    return 0
                }
            }

            function isExpired(plan, start, end) {
                let days = Math.max(0, getDays(end))
                return days === 0
            }

            if (this.props && this.props.onSubscriptionChanged !== undefined) {
                getArtist(this.props.userId, this.CancelToken)
                    .then(async (response) => {
                        const artist = response.data
                        const isSubscribed = !isExpired(artist.sam_plan,
                            artist.sam_plan_start_at, artist.sam_plan_expire_at)
                        this.props.onSubscriptionChanged(isSubscribed, {
                            type: artist.sam_plan,
                            expired: isExpired(artist.sam_plan, artist.sam_plan_start_at, artist.sam_plan_expire_at),
                            plan_start: artist.sam_plan_start_at,
                            plan_end: artist.sam_plan_expire_at
                        })
                    })
                    .catch((error) => {
                        if (axios.isCancel(error)) {
                            console.log(error)
                        }
                    })
            }
        } catch (e) {
            console.log(e);
        }
    }

    componentDidMount() {
        try {
            let contactStr = 'Please contact it@revart.co for more information'

            function getReasonStr(raw) {
                if (!raw) return 'Unknown'

                return raw.replace("?error=", "").replace("error=", "").replaceAll("_", " ")
            }

            if (this.props.location) {
                if (this.props.location.pathname === URL_SUBSCRIPTION_FAILED ||
                    this.props.location.pathname + "/" === URL_SUBSCRIPTION_FAILED) {
                    const reason = getReasonStr(this.props.location.search)

                    Modal.error({
                        title: 'Subscribe failed',
                        content: <><p>{reason.toUpperCase()}</p> <p>{contactStr}</p></>,
                        afterClose: () => {
                            window.location.href = URL_BILLING
                        }
                    });
                }

                if (this.props.location.pathname === URL_SUBSCRIPTION_CANCEL ||
                    this.props.location.pathname + "/" === URL_SUBSCRIPTION_CANCEL) {
                    const reason = getReasonStr(this.props.location.search)

                    Modal.warn({
                        title: 'Subscribe failed',
                        content: <><p>{"Apologize for any inconvenience caused, " +
                            "but it appears that the subscription checkout has been canceled."}</p>
                            <p>{contactStr}</p></>,
                        afterClose: () => {
                            window.location.href = URL_BILLING
                        }
                    });
                }

                if (this.props.location.pathname === URL_SUBSCRIPTION_SUCCESS ||
                    this.props.location.pathname + "/" === URL_SUBSCRIPTION_SUCCESS) {
                    const reason = getReasonStr(this.props.location.search)

                    Modal.success({
                        title: 'Subscribe successfully',
                        content: <></>,
                        afterClose: () => {
                            window.location.href = URL_BILLING
                        }
                    });
                }
            }

        } catch (e) {
        }

        try {
            this.checkSubscriptionStatus()
            this.checkInterval = setInterval(this.checkSubscriptionStatus, 1000 * 5);
        } catch (e) {
            console.log(e)
        }
    }

    componentWillUnmount() {
        if (this.checkInterval) clearInterval(this.checkInterval)
    }

    render() {
        let flexDirection = 'row'
        if (this.props.breakpoint && this.props.breakpoint.xs) {
            flexDirection = 'column'
        }

        function getExpireDateStr(timestamp) {
            try {
                const date = new Date(timestamp);
                return date.toLocaleString()
            } catch (e) {
            }
            return ""
        }

        return (
            <Row id={'subscribe'}>
                <Col span={24}>
                    <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                        <Col>
                            <Title style={{marginBottom: 16}}>
                                <AccountBookOutlined style={{marginRight: 8}}/>
                                Subscription
                            </Title>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify="center" style={{overflowY: 'hidden'}}>
                        <Radio.Group onChange={this.paymentPeriodChange} value={this.state.paymentPeriod}
                                     defaultValue={this.state.paymentPeriod} buttonStyle="solid"
                                     style={{
                                         marginBottom: "20px",
                                         marginLeft: 'auto',
                                         marginRight: 'auto',
                                         display: 'flex',
                                         flexDirection: flexDirection,
                                         justifyContent: 'center',
                                     }}
                        >
                            <Radio.Button key="yearly" value="yearly">Yearly <Tag color={'#f50'}>-25%</Tag>
                            </Radio.Button>
                            <Radio.Button key="monthly" value="monthly"><span
                                style={{paddingLeft: 16, paddingRight: 16}}>
                                Monthly</span></Radio.Button>
                        </Radio.Group>
                    </Row>
                </Col>
                {this.props.plan?.expired && (
                    <Col span={24} style={{marginBottom: 24}}>
                        <Row justify="center" style={{overflowY: 'hidden'}}>
                            <span>{`Your ${this.props.plan?.type} plan expired on ${getExpireDateStr(this.props.plan.plan_end)}`}</span>
                        </Row>
                    </Col>
                )}
                <Col span={24}>
                    <Row type="flex" justify="center" gutter={[24, 12]}>
                        <SubscriptionPlan email={this.props.email}
                                          plan_name="Basic Plan"
                                          plan="basic"
                                          plan_object={this.props.plan}
                                          price_yearly={this.prices['basic'].price_yearly}
                                          price_yearly_discount={this.prices['basic'].price_yearly_discount}
                                          price_monthly={this.prices['basic'].price_monthly}
                                          price_monthly_discount={this.prices['basic'].price_monthly_discount}
                                          benefits={this.basicPlanBenefits}
                                          paymentPeriod={this.state.paymentPeriod}
                                          buttonDisabled={this.props.plan?.type === "basic"}
                                          outline={true}
                                          expired={this.props.plan?.expired}
                                          is_artist={this.props.role === 'artist'}
                        />
                        <SubscriptionPlan email={this.props.email}
                                          plan_name="Premium Plan"
                                          plan="premium"
                                          plan_object={this.props.plan}
                                          price_yearly={this.prices['premium'].price_yearly}
                                          price_yearly_discount={this.prices['premium'].price_yearly_discount}
                                          price_monthly={this.prices['premium'].price_monthly}
                                          price_monthly_discount={this.prices['premium'].price_monthly_discount}
                                          benefits={this.premiumPlanBenefits}
                                          paymentPeriod={this.state.paymentPeriod}
                                          buttonDisabled={this.props.plan?.type === "premium"}
                                          outline={true}
                                          expired={this.props.plan?.expired}
                                          most_popular={true}
                                          is_artist={this.props.role === 'artist'}
                        />
                        <SubscriptionPlan email={this.props.email}
                                          plan_name="Pro Plan"
                                          plan="pro"
                                          plan_object={this.props.plan}
                                          price_yearly={this.prices['pro'].price_yearly}
                                          price_yearly_discount={this.prices['pro'].price_yearly_discount}
                                          price_monthly={this.prices['pro'].price_monthly}
                                          price_monthly_discount={this.prices['pro'].price_monthly_discount}
                                          benefits={this.proPlanBenefits}
                                          paymentPeriod={this.state.paymentPeriod}
                                          buttonDisabled={this.props.plan?.type === "pro"}
                                          expired={this.props.plan?.expired}
                                          is_artist={this.props.role === 'artist'}
                        />
                    </Row>
                </Col>
            </Row>
        )
    }
}

export default withRouter(withBreakpoint(Subscription))

